// Аккаунт партнёра (гостиницы, гиды, трансферы, рестораны): токен сессии в браузере и запросы с ним.
// Вход — /login, все кабинеты аккаунта — /cabinet. Кабинет турфирмы (/office) — отдельная система входа.
import type { AccountSession } from '@sayohat/shared';
import { api, type ApiError, type ApiOptions } from './api';
import { store } from './storage';

const TOKEN = 'accountToken';
const NAME = 'accountName';

export const accountToken = (): string => store.get<string>(TOKEN, '');
export const accountName = (): string => store.get<string>(NAME, '');
export const isLoggedIn = (): boolean => Boolean(accountToken());

export function saveSession(s: AccountSession): void {
  store.set(TOKEN, s.token);
  store.set(NAME, s.account.name);
}

export function forgetSession(): void {
  store.set(TOKEN, '');
  store.set(NAME, '');
}

/** Заголовок входа (пусто — не вошёл) */
export const authHeaders = (): Record<string, string> => {
  const t = accountToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/** Запрос от имени аккаунта; сессия истекла (401) — забываем токен */
export async function accountApi<T>(url: string, opts: ApiOptions = {}): Promise<T> {
  try {
    return await api<T>(url, { ...opts, headers: { ...authHeaders(), ...opts.headers } });
  } catch (e) {
    if ((e as ApiError).status === 401 && accountToken()) forgetSession();
    throw e;
  }
}

/** Адрес входа с возвратом на текущую страницу */
export const loginUrl = (next = location.pathname + location.search + location.hash): string => `/login?next=${encodeURIComponent(next)}`;

/** Куда вернуться после входа: только свои адреса (не на чужой сайт) */
export function nextAfterLogin(search = location.search): string {
  const n = new URLSearchParams(search).get('next') || '';
  return /^\/(?!\/)[\w\-/?=&#%.]*$/.test(n) && !n.startsWith('/login') ? n : '/cabinet';
}

export async function logout(): Promise<void> {
  await accountApi('/api/account/logout', { method: 'POST', body: {} }).catch(() => null);
  forgetSession();
}
